module.exports = __webpack_public_path__ + "131c5e25a949c2fd51b9e74582a7d32c.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/corporate-settings/company-profile/company-profile.html
// module id = 1266
// module chunks = 0